export default __webpack_public_path__ + "static/media/4.38d06a2b.JPG";